
<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'formaltransferaccountIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'formaltransferaccount',
				windowName: '形式转账',
				windowType: 'modal',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			beforeCreateGrid(formConfig,columns ){
				columns.forEach((item)=>{
					if(item.field=='export_wln'){
						item.slots = {
							default:({row})=>{
								if(!row.export_wln){
									if(row.export_wln_error){
										return <span style="color:#F56C6C;">{row.export_wln_error}</span> 
									}else{
										return <span style="color:#F56C6C;">未同步</span> 							
									}	
								}else{
									return <span>{row.export_wln}</span> 	
								}
							}
						}
					}
				})
				columns.forEach((item)=>{
					if(item.field=='jindietype'){
						item.slots = {
							default: ({row,column}) => {	
								let str= []
								if(row.jindierequire){
									let buff = this.checkjindierequire(row)
									if(buff){
										str.push(<el-tag size="mini" type="success" effect="dark" style="margin-right: 2px;">星</el-tag>)
									}else{
										str.push(<el-tag size="mini" type="danger" effect="dark" style="margin-right: 2px;">星</el-tag>)
									}
									
								}
								str.push(<span>{column.formatter({row:row})}</span>)
								return str
							}
						}
					}
				})
			},
			checkjindierequire(row){
				let data = row.jindierequire
				console.log(data,row)
				let buff = true
				if(row.jindietype == 'CN_BANKTRANSBILL'){
					if(!data.main.FFROMBANKACNTID_FNumber || !data.main.FTOBANKACNTID_FNumber || !data.main.FEXPLANATION){
						buff = false
					}
				}
				if(row.jindietype == 'CN_CASHTRANSBILL'){
					if(!data.main.FOUTCASHACCTID_FNumber || !data.main.FINCASHACCTID_FNumber){
						buff = false
					}
				}
				if(row.jindietype == 'CN_CASHACCESSBILL'){
					if(!data.main.FBillTypeID || !data.main.FBANKACNTID_FNumber || !data.main.FCashAccount_FNumber){
						buff = false
					}
				}
				if(row.jindietype == 'AP_PAYBILL'){
					if(!data.main.FCONTACTUNITTYPE || !data.main.FCONTACTUNIT_FNumber || !data.main.FACCOUNTID_FNumber){
						buff = false
					}
					data.transferaccounts_detail.forEach((item)=>{
						if(!item.FPURPOSEID_FNumber || !item.FSETTLETYPEID_FNumber){
							buff = false
						}
					})					
				}
				if(row.jindietype == 'AR_RECEIVEBILL'){
					if(!data.main.FPAYUNITTYPE || !data.main.FPAYUNIT_FNumber || !data.main.FACCOUNTID_FNumber){
						buff = false
					}
					data.transferaccounts_detail.forEach((item)=>{
						if(!item.FPURPOSEID_FNumber || !item.FSETTLETYPEID_FNumber){
							buff = false
						}
					})
					
				}
				return buff
			},
			sendwln(){
				let data =  this.$refs[this.moduleName + '_list'].getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				this.loading = true

				data.forEach((item)=>{
					this.$api[this.moduleName].sendwln({id:item.id}).then(()=>{
						this.loading = false
						this.customreload()
					},()=>{
						this.loading = false
					})
				})
				
			},
			close(row){
				this.$confirm('是否确认关闭').then(()=>{
					this.$api[this.moduleName].close({id:row.id}).then(()=>{
						this.loading = false
						this.customreload()
					},()=>{
						this.loading = false
					})
				})
			}
		},
		components: {
			
		}
	}
</script>
